import { render, staticRenderFns } from "./myFavorite.vue?vue&type=template&id=52d2f55e&scoped=true"
import script from "./myFavorite.vue?vue&type=script&lang=js"
export * from "./myFavorite.vue?vue&type=script&lang=js"
import style0 from "./myFavorite.vue?vue&type=style&index=0&id=52d2f55e&prod&lang=stylus&rel=stylesheet%2Fstylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d2f55e",
  null
  
)

export default component.exports